class PromoBanner extends HTMLElement {
  constructor() {
    super();

    this.enabled = this.getAttribute('repeat-and-scroll') === 'true' || false;
    if (!this.enabled) return;

    this.marqueeElement = this.querySelector('.promotional-banner__text :first-child');
    this.gap = Number(this.getAttribute('gap'));
    this.animationSpeed = this.getAttribute('speed');
    this.rafId = null;
    this.cloneCount = 0;
  }

  connectedCallback() {
    this.style.setProperty('--marquee-element-width', `${this.marqueeElement.offsetWidth}px`);
    this.addClones(this.getNumClonesToFillTheViewport());
    this.setAnimationDuration(this.marqueeElement, this.animationSpeed);
    window.addEventListener('resize', this.onResize.bind(this), { passive: true });
  }

  getNumClonesToFillTheViewport() {
    // calc how many elements are needed to fill the viewport, rounded up
    return Math.ceil(window.innerWidth / this.marqueeElement.offsetWidth);
  }

  onResize() {
    if (this.rafId !== null) return;

    let newCloneCount;

    this.rafId = requestAnimationFrame(() => {
      this.rafId = null;

      newCloneCount = this.getNumClonesToFillTheViewport();
      if (this.cloneCount < newCloneCount) {
        const diff = newCloneCount - this.cloneCount;
        this.addClones(diff);
      }
    });
  }

  addClones(num) {
    // clone the original element and hide the clones from assitive tech
    const cloneElement = this.marqueeElement.cloneNode(true);
    cloneElement.ariaHidden = true;
    cloneElement.hidden = true;

    // create markup for the clones
    let markup = cloneElement.outerHTML;
    markup = markup.repeat(num);

    // update the running total of clones
    this.cloneCount += num;

    // add clones to the page
    this.marqueeElement.insertAdjacentHTML('afterend', markup);
  }

  setAnimationDuration(element, pace) {
    // pixels per second
    const speeds = {
      slow: 10,
      medium: 25,
      fast: 50,
    };
    const elWidth = element.offsetWidth + this.gap;
    const duration = elWidth / speeds[pace];
    this.style.setProperty('--marquee-animation-duration', `${duration}s`);
  }
}

if (!customElements.get('promo-banner')) {
  customElements.define('promo-banner', PromoBanner);
}
